import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Transition, animated } from 'react-spring/renderprops'
import Spinner from './Spinner'
import { getEmbeddedViewFlag } from 'portal-modules/common/utils/get-embedded-flag'
import styled from '@emotion/styled'

const StyledWrapperDiv = animated(styled('div')`
  background-color: ${({ theme }) =>
    getEmbeddedViewFlag()
      ? theme.embedded.background_color
      : theme.mode.isDark
        ? 'rgba(0, 0, 0, 0.85)'
        : 'rgba(255, 255, 255, 0.85)'};
  color: ${({ theme }) => theme.secondary.base};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: ${({ theme }) => theme.fonts.regular};
  font-size: 18px;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;

  p {
    margin: 24px 0;
    color: ${({ theme }) => theme.button_secondary.color};
    font-size: 21px;
    font-weight: 700;
  }

  /* Hide loader in mobile/tablet for better UX */
  @media only screen and (max-width: 1024px) {
    display: none !important;
  }
`)

const FullscreenLoader = props => {
  const toggleBlur = action => {
    document.getElementById('root')?.classList[action]('blur-bg')
  }

  useEffect(() => {
    toggleBlur(props.show ? 'add' : 'remove')
    return () => {
      toggleBlur('remove')
    }
  }, [props.show])

  const { children, show } = props

  return (
    <Transition
      items={show}
      from={{ opacity: 0 }}
      enter={{ opacity: 1 }}
      leave={{ opacity: 0 }}
      native
    >
      {show =>
        show &&
        (styles => (
          <StyledWrapperDiv style={styles}>
            <Spinner size={80} />
            <p>{children}</p>
          </StyledWrapperDiv>
        ))
      }
    </Transition>
  )
}

FullscreenLoader.propTypes = {
  children: PropTypes.any,
  show: PropTypes.bool,
}

export default FullscreenLoader
